<!-- This is static legal verbage approved by Origence legal team -->
<div class="bl-margin-x--16">
  <div class="bl-max-width--layout bl-margin-x--auto bl-margin-y--48">
    <header class="bl-display--flex bl-align-items--flex-start">
      <h1 class="bl-flex--auto bl-text-style--display-2 bl-margin-bottom--0 bl-margin-right--16">
        Origence Terms of Use and Privacy Policy
      </h1>
      <button type="button" class="bl-button bl-button-tertiary bl-padding--8 bl-print-hide" (click)="print()">
        {{ 'action/print' | dictionary }}
      </button>
    </header>

    <!-- TODO: add anchor links-->
    <article
      class="bl-block-module bl-bg-color--white bl-margin-x--auto bl-max-width--tablet-width bl-margin-top--24 bl-margin-top-md--48 bl-position--relative bl-padding-x--24 bl-padding-y--40 bl-padding-md--40 bl-margin-bottom--32"
    >
      <h2 class="bl-text-style--display-4">Terms of Use</h2>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">General Terms of Use</span>
        </h3>
        <p class="bl-padding-left--8">
          You are currently viewing a page of the ORIGENCE.com website or a related web site (the “Site”) belonging to CU Direct dba
          Origence for itself and its wholly owned affiliates, with the exception of FI Connect, LLC, (collectively, “Origence”) that
          provides services. The use of this Site and any of the services provided by Origence in connection with this Site (the “Services”)
          are being provided to you expressly subject to these Terms of Use (the “Terms”). These Terms shall govern your use of this
          website.
        </p>
        <p class="bl-padding-left--8">
          “Services” under these Terms include financial services offered by Origence or third-party Financial Institutions, and additional
          services available to you through independent third-party service providers accessed through navigation of this Site.
        </p>
        <p class="bl-padding-left--8">
          By accessing, visiting, browsing, or interacting with any part of this Site, you agree that you are at least 13 years of age and
          that you have read, understand, these terms and the Privacy Policy
          <link />
          and agree to be bound by all of the terms of these Terms and the Privacy Policy.
        </p>
        <p class="bl-padding-left--8">
          Origence reserves the right to make changes to these Terms and to the Site, without prior notice, at Origence’s sole discretion.
          Continued use by any party of this Site constitutes your acceptance of these changes and the most up-to-date version of these
          Terms of Use. The most current version of this agreement, which will supersede all previous versions, can be viewed by clicking
          the “Terms of Use” hyperlink located at the bottom of the Origence website homepage.
        </p>
        <p class="bl-padding-left--8">
          You understand and agree that effective use of this Site may require your browser to use software plug-ins and modules in order to
          correctly display content and utilize features on the Site. YOU ACKNOWLEDGE THAT NEITHER ORIGENCE NOR ITS AFFILIATES OR ANY OF
          THEIR RESPECTIVE EMPLOYEES, AGENTS, THIRD-PARTY CONTENT PROVIDERS, OR LICENSORS WARRANTS THAT USE OF THIS SITE WILL BE
          UNINTERRUPTED OR ERROR FREE. FURTHERMORE, NONE OF THE AFOREMENTIONED PARTIES MAKE ANY WARRANTY AS TO THE RESULTS THAT MAY BE
          EXPERIENCED FROM USE OF THE SERVICES OR THIS SITE, OR AS TO THE ACCURACY, RELIABILITY, COMPLETENESS, OR CONTENT OF ANY OF THE
          INFORMATION, SERVICES, OR MERCHANDISE PROVIDED THROUGH THE SITE AND ANY SERVICES ON THE SITE, OR ANY SITE CONNECTED TO THIS SITE
          VIA HYPERLINK OR OTHERWISE. THIS DOES NOT AFFECT ANY MANUFACTURER’S OR THIRD-PARTY WARRANTIES THAT THE PROVIDERS OF THE LINKED
          SITES OTHERWISE MAY OFFER.
        </p>
        <p class="bl-padding-left--8">
          EXCEPT AS SPECIFICALLY PROVIDED IN THESE TERMS OR WHERE THE LAW REQUIRES AN ALTERNATIVE STANDARD, YOU AGREE THAT ORIGENCE IS NOT
          RESPONSIBLE FOR ANY LOSS, PROPERTY DAMAGE, ACCIDENT OR INJURY CAUSED EITHER BY ACCESS TO OR USE OF THE SERVICES OR THE SITE. TO
          THE MAXIMUM EXTENT PERMISSIBLE UNDER APPLICABLE LAW, ORIGENCE WILL NOT BE RESPONSIBLE TO YOU OR ANY THIRD-PARTY CLAIMING THROUGH
          YOU ANY DIRECT, INDIRECT, SPECIAL, CONSEQUENTIAL, ECONOMIC, OR OTHER DAMAGES ARISING IN ANY WAY OUT OF THE INSTALLATION OR USE OF
          THE SERVICES, THE SITE, BROWSER SOFTWARE, AND THE LIKE. THIS INCLUDES ANY LIABILITY ASSOCIATED WITH ANY COMPUTER VIRUSES, “WORMS”
          AND THE LIKE WHICH MAY INFECT YOUR COMPUTER SYSTEM.
        </p>
        <p class="bl-padding-left--8">
          THE SERVICES ARE OFFERED ON AN “AS IS” AND “WHERE AVAILABLE” BASIS, WITH NO WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED, OR
          STATUTORY- INCLUDING BUT NOT LIMITED TO WARRANTIES OF TITLE OR THE IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A
          PARTICULAR PURPOSE. THIS DOES NOT AFFECT THOSE WARRANTIES WHICH ARE INCAPABLE OF EXCLUSION, RESTRICTION, OR MODIFICATION UNDER THE
          LAWS APPLICABLE TO THIS AGREEMENT.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Access, Registration, and Submissions of Information</span>
        </h3>
        <p class="bl-padding-left--8">
          In order to access this Site or some of the resources offered herein, you may be invited to register personal or business
          information. This will allow Origence to tailor its Services to your personal needs and alert you to other products and Services
          that may be helpful to you and/or your business.
        </p>
        <p class="bl-padding-left--8">
          Your continued use of this Site is conditioned upon the correct, current, and complete provision of any such information. If
          Origence believes that the information you provide is not correct, current, or complete, Origence retains the right to refuse you
          access to this Site or to any of its resources, and to terminate or suspend your access at any time and without prior notice.
        </p>
        <p class="bl-padding-left--8">
          As a convenience to you, any information you provide through this Site may be kept in a profile for you and/or your business. This
          profile and any of the information you provide will be protected to the extent described in our Privacy Policy below.
        </p>
        <p class="bl-padding-left--8">
          If you are enrolled in any online services provided by Origence, your use of those Services is governed by the agreement executed
          by you and Origence upon consummation of your enrollment (the “Enrollment”), which may incorporate these Terms by reference. If
          there is any conflict between these Terms and the Enrollment, the Enrollment will control.
        </p>
        <p class="bl-padding-left--8">
          Except with regard to non-public personal information, you hereby grant to Origence the royalty-free, perpetual, irrevocable,
          complete, non-exclusive right and license to use, reproduce, modify, adapt, publish, translate, distribute, and display all
          content, remarks, suggestions, ideas, or other information communicated by you to Origence through this site, (together,
          “Submissions”), and to incorporate any Submissions in other works in any form, media, or technology now known or later developed.
          Except with regard to the provisions set forth in the Privacy Policy, Origence will not be required to treat any Submission as
          confidential and may use any Submission in its business without incurring any liability for royalties or any other consideration
          of any kind, and will not incur any liability as a result of any similarities that may appear in future Origence operations.
        </p>
        <p class="bl-padding-left--8">
          Origence reserves the right to modify or terminate the Services and your use of this Site or to modify or terminate your access to
          the Services and Site, in whole or in part, at any time and without prior notice.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Restrictions on Use</span>
        </h3>
        <p class="bl-padding-left--8">
          You may use this site for purposes expressly permitted in these Terms. As a condition of these Terms, you warrant to Origence that
          you will not use the Site for any purpose that is unlawful or prohibited by these Terms, and any subsequent amendments, notices or
          state or federal law.
        </p>
        <p class="bl-padding-left--8">
          You may not participate in or authorize any party to participate in activities including but not limited to co-branding, framing,
          or hyperlinking to this Site without the express prior written permission of an authorized representative of Origence.
          “Co-branding,” for the purposes of these Terms, means the display of a name, logo, trademark, or other means of attribution or
          identification of one party in such a manner as is reasonably likely to give a viewer the impression that such other party has the
          right to display, publish, or distribute content from or accessible within this Site. You may not use the Site or Services in any
          way which could disable, overburden, damage, or impair the Site, or interfere with any other party’s use and enjoyment of the
          Site.
        </p>
        <p class="bl-padding-left--8">
          This Site is for your personal and non-commercial use, except where otherwise specified, as with businesses who have engaged with
          us under a separate written agreement. You may not use this site for any purpose other than those specifically allowed in these
          Terms. You may not modify, copy, distribute, display, send, perform, reproduce, publish, license, create derivative works from,
          transfer, or sell any information, content, software, products or services obtained from or otherwise connected to this Site. You
          may not obtain or attempt to obtain any materials, content, or information through any means not intentionally made available or
          provided for through the Site.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Trademarks, Copyrights, and Other Proprietary Information</span>
        </h3>
        <p class="bl-padding-left--8">
          All of the pages, screens, material, and content accessible from this Site (the “Content”) is the proprietary information of
          Origence or the party that provided or licensed the Content to Origence, whereby Origence or the providing party retains all
          rights, title, and interest in the Content. The Content is protected by United States copyright laws and international treaties.
          The Content may not be copied, distributed, republished, uploaded, posted, or transmitted in any way without the prior written
          consent of Origence.
        </p>
        <p class="bl-padding-left--8">
          The above provisions do not affect your right to print a copy of the Content solely for personal use. In doing so, however, you
          may not remove, alter, or cause to be removed or altered, any trademark, trade name, service mark, or other proprietary notice or
          legend appearing on the Content. Modification or use of the Content except as expressly provided in these Terms is a violation of
          Origence’s intellectual property rights. Neither title nor intellectual property rights are transferred to you by granting you
          access to this Site.
        </p>
        <p class="bl-padding-left--8">
          Trademarks, service marks, logos, and copyrighted works appearing on the Site are property of Origence or the party that provided
          the trademarks, service marks, logos, or copyrighted works to Origence. Origence and such parties retain all rights associated
          with any of the respective trademarks, service marks, logos, and copyrighted works appearing on the Site.
        </p>
        <p class="bl-padding-left--8">
          If you believe in good faith that materials available on this or any other Origence Site infringe your copyright, you may send
          Origence a notice requesting removal of such material. If you believe in good faith that Origence or one of its third-party
          affiliates has wrongfully filed a notice of copyright infringement against you related to this Site, the Digital Millennium
          Copyright Act provides that you may send to Origence a counter-notice. Details on notices and counter-notices are available on the
          United States Copyright Office website at www.copyright.gov.
        </p>
        <p class="bl-padding-left--8">
          The Site may be hyper-linked to other sites which are not maintained by or related to Origence. Such hyper-links are provided as a
          Service to users and are not sponsored by or affiliated with Origence. Origence has not reviewed any or all of such sites and is
          not responsible for the content of those sites.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Use of Communication Services</span>
        </h3>
        <p class="bl-padding-left--8">
          The Site may contain or provide access to forums, bulletin or chat services, message boards, and/or other message or communication
          facilities (collectively, “Communication Services”). Origence makes no warranty that these Communication Services will be
          available at any particular time or will be free of fault or error. These Communication Services are provided as a convenience to
          facilitate your understanding and use of Origence’s products and services. You will not use these Communication Services to send
          any abusive, defamatory, dishonest, or obscene message, to transmit any proprietary material belonging to another party, that
          violates any law or may be considered to violate any law, or that advertises or engages in commercial activity. Violation of this
          section may result in terminating your use of the Communication Services.
        </p>
        <p class="bl-padding-left--8">
          Origence reserves the right to monitor use of this site to determine compliance with these Terms, as well as the right to remove
          or refuse any information for any reason. Origence reserves the right to terminate your access to any and/or all Communication
          Services at any time, for any reason, and without advance notice. Origence also reserves the right at all times to disclose any
          information as necessary to satisfy any applicable law, regulation, legal process of governmental request, or to edit or remove
          any information transmitted through the Communication Services, in whole or in part, in its sole discretion. Materials submitted
          through a Communication Service may be subject to limitations on use, reproduction, and dissemination and you are responsible for
          abiding by such limitations.
        </p>
        <p class="bl-padding-left--8">
          Notwithstanding the above provisions, you remain solely responsible for the content of your submissions. You acknowledge and agree
          that neither Origence nor any third-party affiliate of Origence will assume any liability related to any action or inaction by
          Origence or such third-party with respect to your submissions and use of the Communication Services. Origence specifically
          disclaims any liability with respect to the Communication Services and any actions resulting from your participation in any
          Communication Service. Managers and hosts are not authorized Origence spokespersons, and their views do not necessarily reflect
          those of Origence.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Limitations on Liability</span>
        </h3>
        <p class="bl-padding-left--8">
          Origence, its subsidiaries, affiliates, employees, agents, officers, and directors will NOT be liable for any incidental, direct,
          indirect, punitive, actual, consequential, special, exemplary, or other damages, including loss of revenue or income, pain and
          suffering, emotional distress, or similar damages. Even if Origence has been advised of the possibility of such damages, in no
          event will the collective liability of Origence and its subsidiaries, affiliates, employees, agents, officers, and directors to
          any party exceed the greater of $100 or the amount you have paid to Origence for the applicable content or service out of which
          liability arose.
        </p>
        <p class="bl-padding-left--8">
          You will indemnify and hold Origence, its subsidiaries, affiliates, employees, agents, officers, directors, and contractors (the
          “Indemnified Parties”) harmless from any breach of these Terms by you, including any use of Content other than expressly
          authorized in these Terms. You agree that the Indemnified Parties will have no liability in connection with any such breach or
          unauthorized use, and you agree to indemnify any and all resulting loss, damages, judgments, awards, costs, expenses, and
          attorneys’ fees of the Indemnified Parties in connection therewith. The Indemnified Parties shall also be held harmless from and
          against any claims brought by third parties arising out of your use of this site.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Automotive Transactions</span>
        </h3>
        <p class="bl-padding-left--8">
          Disclaimer regarding automotive transactions: The Site may include and enable vehicle listings provided by third parties,
          including automobile dealerships, private sellers, data aggregators, and other sources. The vehicle listed on or through the Site
          may not be available at the time the Site is viewed; if any vehicle is no longer available, neither Origence nor the seller are
          obligated to sell a similar vehicle to you at the same price. You must contact the seller to confirm that such vehicle is
          available. All vehicle information, including availability, price, description, finance terms, and options, is provided to this
          Site by third parties, and we are not responsible for the accuracy of the information provided. Finance terms may change based on
          the year, make and model of the vehicle as well as changes in your credit profile from the time pre-qualification is evaluated on
          or through this Site to when the vehicle transaction is completed.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Third-Party Services</span>
        </h3>
        <p class="bl-padding-left--8">
          Origence will be utilizing the services of certain third-parties to provide you the services you are requesting. Origence
          specifically disclaims any responsibility or liability for the services or products provided by such third-parties, and Origence
          is not responsible for the accuracy of any such information provided.
        </p>
        <p class="bl-padding-left--8">
          Our platform facilitates direct communication and information sharing between you, the consumer, and third-party financial
          institutions. This is made possible through the integration of third-party service providers. You expressly understand and agree
          that Origence is not responsible for and does not warrant the actions, practices, or policies of third-party financial
          institutions or service providers in relation to the use of your information.
        </p>
        <p class="bl-padding-left--8">
          Origence shall not be liable for any misuse, unauthorized access, or improper handling of your information by third-party
          financial institutions or service providers. By using our services, you expressly consent to the direct communication and
          information sharing with third-party financial institutions and service providers as facilitated by our platform. Third-parties
          may also record your audio or video calls with third-party financial institutions.
        </p>
        <p class="bl-padding-left--8">
          It is your responsibility to review and understand the privacy policies and terms of use of third-party financial institutions
          before engaging with them through our platform.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Chat and Session Replay Features</span>
        </h3>
        <p class="bl-padding-left--8">
          Origence and our third-party service providers may use chat bot or session replay tools that may track your movements on our
          websites; your movements and actions outside of the website will not be tracked. This is done to better assist in your experience
          with our site and products and services you may wish to access. You can manage tracking by going to your cookie settings. See
          Origence’s Privacy Policy to better understand how the information is used below.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Miscellaneous</span>
        </h3>
        <p class="bl-padding-left--8">
          These Terms will be governed and interpreted pursuant to the laws of the state of California. You specifically consent to personal
          jurisdiction in California in connection with any dispute between you and Origence arising out of these Terms or pertaining to the
          subject matter hereof. If any part of these Terms is unlawful, void, or unenforceable, that part will be deemed severable and will
          not affect the validity and enforceability of any remaining provisions.
        </p>
        <p class="bl-padding-left--8">
          You agree that no joint venture, partnership, employment, or agency relationship exists between you and Origence as a result of
          these Terms or the use of the Site. These Terms constitute the entire terms and conditions among the parties relating to this
          subject matter and supersedes all prior or contemporaneous communications and proposals, whether electronic, oral, or written,
          between you and Origence with respect to the Site.
        </p>
        <p class="bl-padding-left--8">
          A printed version of these Terms and of any notice given in electronic form shall be admissible in judicial or administrative
          proceedings based upon or relating to these Terms to the same extent and subject to the same conditions as other business
          documents and records originally generated and maintained in printed form.
        </p>
        <p class="bl-padding-left--8">
          Notwithstanding the foregoing, any additional terms and conditions on the Site will govern the items to which they pertain.
          Origence may revise these Terms of Use at any time by updating this posting.
        </p>
        <p class="bl-padding-left--8">
          Origence® websites © 2024; All rights reserved. CU Direct Corporation dba Origence, is headquartered at 18400 Von Karman, Suite
          900, Irvine, CA 92612.
        </p>
      </section>
    </article>

    <article
      class="bl-block-module bl-bg-color--white bl-margin-x--auto bl-max-width--tablet-width bl-margin-top--24 bl-margin-top-md--48 bl-position--relative bl-padding-x--24 bl-padding-y--40 bl-padding-md--40"
    >
      <h2 class="bl-text-style--display-4">Origence Privacy Policy and Notice</h2>
      <p class="bl-font-color--slate bl-font-weight--800">Effective date January 15, 2026</p>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">About Us</span>
        </h3>
        <p class="bl-padding-left--8">
          CU Direct Corporation dba Origence for itself and its wholly owned affiliates, with the exception of FI Connect, LLC
          (collectively, “Origence”), is a third-party service provider to automotive dealerships and certain financial institutions, (our
          “Clients”) on whose behalf we collect personal information pursuant to a written contract, and where the automotive dealership and
          /or financial institution determines the purpose and means of processing the personal information. When we receive or process
          information on behalf of our Clients, the processing of that information is governed by our Client’s privacy notice and our
          Clients are solely responsible for taking action or making changes to any consumer information that is submitted through our
          systems.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Our Commitment to Your Privacy</span>
        </h3>
        <p class="bl-padding-left--8">
          Our goal is to protect the privacy of our Clients, and their customers. This Privacy Policy is in effect for information we
          collect and/or own through our website, online services, third-party providers, or applications submitted by our Clients
          (collectively, “Information Channels”). This Privacy Policy may be updated or modified at any time and shall become effective once
          the Privacy Policy is made available for viewing.
        </p>

        <p class="bl-margin-bottom--8">This Privacy Policy and Notice (“Privacy Policy”) describes:</p>
        <ul class="bl-bulleted-list">
          <li>How and why we collect certain information from you via our services.</li>
          <li>How we use and with whom we share this information.</li>
          <li>How you can access and update this information.</li>
          <li>The choices you can make about how we collect, use and share your information.</li>
          <li>How we safeguard your information.</li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">How to Contact Us</span>
        </h3>
        <p class="bl-padding-left--8">
          If you have any questions regarding this Privacy Policy or our information collection and use practices, please contact us at
          <a href="mailto:privacy@origence.com">privacy&#64;origence.com</a>
          , OR
          <a href="tel:+18339080121">1-833-908-0121</a>
          and follow the telephone prompts OR by mail at Origence, 18400 Von Karman, Suite 900, Irvine, CA 92612, Attn: PRIVACY.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Safeguards</span>
        </h3>
        <p class="bl-padding-left--8">
          Origence maintains industry safeguards, in accordance with applicable federal and state laws and regulations, to keep your
          personal information safe and secure. When we provide personal information to financial entities, our affiliates, or third-party
          service providers, we require that these parties agree to process and keep the information in compliance with applicable privacy
          laws. The use of your information by our business partners may be subject to that party’s own privacy notice. Unless we are
          permitted by law, we will not disclose the information we collect about you from consumer or credit reporting agencies, without
          your consent. For certain online features or services, such as those that that may include personal information, we require the
          use of username/password and/or encryption technologies for the protection of your personal information. You are responsible for
          protecting your username, password, and other user account information from disclosure to third parties, and you are restricted
          from circumventing the use of required encryption technologies. You agree to: (a) immediately notify us at
          <a href="mailto:privacy@origence.com">privacy&#64;origence.com</a>
          of any unauthorized use of your username, password, and/or user account information, and/or any other breach of security; and (b)
          make sure that you log out from your user account at the end of each session. While we may provide certain safeguards to protect
          your confidential information, we do not and cannot guarantee or warrant that any information transmitted through the Internet is
          secure, or that such transmissions are free from delay, interruption, interception, or error.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Types of Information Collected</span>
        </h3>
        <p class="bl-padding-left--8">
          To perform our services, we may collect certain information from you, and third parties we engage may also collect such
          information for the purpose of hosting, configuring, maintaining, operating, administering, designing and supporting our systems,
          and providing services to the financial entities with whom you do business. We do not share your personal information with third
          parties other than as set forth in this Privacy Policy. Each financial entity’s privacy notice shall apply to you and your
          personal information, and you should refer to those privacy notices to understand how the financial entity uses and processes your
          personal information. Origence is not responsible, nor liable, for the practices, privacy notices and their content, of third
          parties, including the financial entities with whom we, and you, do business.
        </p>
        <p class="bl-margin-bottom--8">
          Personal information that Origence may collect includes, but is not limited to, the following categories of information:
        </p>
        <ul class="bl-bulleted-list">
          <li>Contact (i.e., first/last name, mailing or property address, phone number, email address)</li>
          <li>Financial Transactions (i.e., loan number, account number).</li>
          <li>Other personal information required by financial entities in order to provide services to you.</li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Browsing Information</span>
        </h3>
        <p class="bl-padding-left--8">
          Like most online services, we collect standard technical information when you use our services, including, but not limited to
          unique device identifiers, internet protocol (IP) addresses, browser types, internet service providers (ISPs), the number and
          duration of page visits and the number of clicks. We may use cookies, which are small pieces of data stored on your device which
          include an anonymous unique identifier, for session purposes. We may use tracking systems for certain systems, and we recognize Do
          Not Track requests from internet browsers or similar devices with regard to consumers, but not for financial institution employees
          acting within the scope of their employment. Certain third-party providers which you choose to do business with may deploy tags or
          pixels on our websites to facilitate tracking, analytics and remarketing to you. As a result, these third-party tags may collect
          information about your interaction with our website, including but not limited to IP address, browsing activity. The data
          collection and processing practices of these third parties are governed by their privacy policies.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">How We Collect Information</span>
        </h3>
        <p class="bl-margin-bottom--8">Information about you may be collected by Origence from the following sources:</p>
        <ul class="bl-bulleted-list">
          <li>Applications or other forms we receive from you or your authorized representative.</li>
          <li>Correspondence you or others send to us.</li>
          <li>Information we receive through our Information Channels, financial institutions, and third-party providers.</li>
          <li>
            Information from consumer or other credit reporting agencies and public records maintained by government entities that we obtain
            directly from those entities, including your credit worthiness and credit history.
          </li>
          <li>Information we receive from other sources, as permitted by applicable, laws, and regulations.</li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Use of Collected Information</span>
        </h3>
        <p class="bl-margin-bottom--8">
          The information we collect from you, or others on your behalf, is used for the following business purposes:
        </p>
        <ul class="bl-bulleted-list">
          <li>
            To provide products and services to you or any financial entity or other third party who is obtaining services on your behalf,
            or in connection with a transaction involving you.
          </li>
          <li>To communicate with you regarding your transaction or our products and services.</li>
          <li>To improve our products and services.</li>
          <li>To personalize your user experience regarding our Information Channels.</li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">When Information is Disclosed</span>
        </h3>
        <p class="bl-padding-left--8">
          We are permitted by law to provide your personal information to various companies and individuals, without obtaining your
          permission. Certain laws do not allow you to restrict these disclosures. In the section below entitled “Your Information Choices,”
          we share with you how to limit certain disclosures of your personal information. Origence may disclose information including, but
          not limited to, the following situations, to affiliates and third parties, unless otherwise restricted by applicable law:
        </p>
        <ul class="bl-bulleted-list">
          <li>
            To third parties to provide you with services you have requested, and to enable us to detect or prevent fraud,
            misrepresentation, or criminal activity.
          </li>
          <li>To third parties that provide services on our behalf and use the information only in connection with such services.</li>
          <li>
            To law enforcement or other government authorities in connection with an investigation, civil or criminal subpoena, or court
            order.
          </li>
          <li>
            To other third parties with whom you have given us written, including electronic authorization to disclose your personal
            information.
          </li>
          <li>To investigate potential unauthorized use of our Information Channel.</li>
          <li>
            To share and use, for any purpose, the personal information if it is in an aggregated, anonymized form, so that you are not
            identified (collectively, “De-Identified Data”).
          </li>
          <li>
            In connection with a sale, transfer or other disposition of all or part of Origence’s business/assets, or in the event of
            bankruptcy, reorganization, receivership, insolvency, or assignment for the benefit of creditors.
          </li>
          <li>For any purpose disclosed by us to you when you provide the information, and as directed by you, or with your permission.</li>
          <li>
            (i) to understand and analyze trends and preferences; (ii) to monitor and analyze our services’ effectiveness; (iii) to improve
            our services and develop new products, services, features, and functionality; (iv) to personalize our services, such as
            remembering your information so that you will not have to re-enter it during your visit or the next time you use our services,
            and (v) to provide customized content and information.
          </li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Your Information Choices</span>
        </h3>

        <p class="bl-margin-bottom--8">
          You consent to the collection and use of your information by Origence in compliance with this Privacy Policy by your submitting
          personal information to Origence, or using our services, unless you inform us otherwise, as allowable by law. Your available
          information choices are set forth below. Origence may use your personal information for the following purposes, which such use
          cannot be limited by you:
        </p>
        <ul class="bl-bulleted-list">
          <li>
            For our everyday business purposes – to process services, respond to law enforcement or other government authorities regarding
            an investigation, and subpoenas or court orders.
          </li>
          <li>For our own marketing purposes.</li>
          <li>For joint marketing with financial companies.</li>
          <li>For our affiliates' everyday business purposes, we may share information about your transaction and experiences.</li>
        </ul>
        <p class="bl-margin-bottom--8">
          You may choose to prevent Origence from disclosing or using your personal information in the following circumstances:
        </p>
        <ul class="bl-bulleted-list">
          <li>For our affiliates' everyday business purposes – information about your credit worthiness,</li>
          <li>For our affiliates to market to you.</li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Updates and Corrections</span>
        </h3>
        <p class="bl-padding-left--8">
          To update or correct your personal information we maintain for our own business purposes, please refer to the “How to Contact Us”
          section at the beginning of this Privacy Policy. Please be advised, in those cases where we are acting as a third-party service
          provider to a financial institution, you must contact your financial institution to update or correct your personal information.
          See the “For California Residents” section below for additional information.
        </p>
      </section>
      <section class="bl-margin-bottom--24 bl-padding-top--24 bl-border-top--1 bl-border-color--mist">
        <h3 class="bl-text-style--display-5 bl-margin-bottom--16">
          <span class="bl-font-color--steel bl-font-weight--800">For California Residents:</span>
        </h3>
        <h4 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">California Privacy Policy and Notice at Collection</span>
        </h4>
        <p><em>Effective and updated as of January 15, 2026</em></p>
        <p class="bl-padding-left--8">
          The California Consumer Privacy Act of 2018, as amended by the California Privacy Rights Act (CCPA), gives California (CA)
          consumers certain rights over their personal information as detailed below. Under the CCPA, Origence is a third-party service
          provider to automotive dealerships and certain financial institutions ("Clients"), on whose behalf we collect personal information
          pursuant to a written contract, and where the Client determines the purpose and means of processing the personal information. When
          we receive or process information on behalf of one of our clients, the processing of that information is governed by our client's
          privacy notice. The client is solely responsible for making changes to any consumer information that is submitted through our
          systems and verifying your CCPA requests prior to submitting them to us.
        </p>
        <p class="bl-font-weight--700">The CCPA provides the following consumer rights:</p>
        <p class="bl-margin-bottom--8">
          <span class="bl-font-weight--700 bl-font-size--18">Right to Know</span>
          about the personal information a business collects about them, how it is used or shared. If we receive a verified request, you
          have not made this request more than twice in a 12-month period, and the information is subject to the CCPA, we will disclose to
          you:
        </p>
        <ul class="bl-bulleted-list">
          <li>The categories of personal information we collected about you in the last 12 months.</li>
          <li>The categories of sources from which your personal information was collected.</li>
          <li>Our business or commercial purpose for collecting, using or disclosing your personal information.</li>
          <li>
            If we disclosed your personal information for a business purpose, the categories of personal information disclosed in the last
            12 months.
          </li>
          <li>The categories of third parties with whom we disclose your personal information in the last 12 months.</li>
          <li>The specific pieces of personal information we collected about you (also called a data portability request).</li>
          <li>
            If we sold your personal information, the categories of personal information sold and the categories of third parties to whom
            personal information was sold.
          </li>
        </ul>

        <p class="bl-padding-left--8">
          Origence does not and has not, within the preceding 12 months, “sold” or “shared” consumer’s personal information to “third
          parties,” as such terms are defined in the CCPA, for a business or commercial purpose.
        </p>
        <p class="bl-padding-left--8">
          We will not provide you with specific pieces of personal information if the disclosure creates a substantial, articulable, and
          unreasonable risk to the security of the personal information, your account with us, or the security of our systems or networks.
        </p>
      </section>
      <section class="bl-margin-bottom--24">
        <p>
          <span class="bl-font-weight--700">Information We Collect.</span>
          Information that Origence may collect includes, but is not limited to, the following categories of personal information or
          sensitive information within the last 12 months:
        </p>
        <table border="1">
          <caption class="bl-display--none">Table 1: Categories of Personal Information Collected</caption>
          <thead>
            <tr>
              <th class="bl-padding--8">Category</th>
              <th class="bl-padding--8">Examples</th>
              <th class="bl-padding--8">Collected</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="bl-padding--8">A. Identifiers.</td>
              <td class="bl-padding--8">
                A real name, date of birth, alias, postal address, unique personal identifier, online identifier, Internet Protocol address,
                email address, account name, Social Security number, driver's license number, passport number, or other similar identifiers.
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">
                B. Personal information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).
              </td>
              <td class="bl-padding--8">
                A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport
                number, driver's license or state identification card number, insurance policy number, education, employment, employment
                history, bank account number, credit card number, debit card number, or any other financial information, medical
                information, or health insurance information.
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">C. Protected classification characteristics under California or federal law.</td>
              <td class="bl-padding--8">
                Age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical
                condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth
                and related medical conditions), sexual orientation, veteran or military status, genetic information (including familial
                genetic information).
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">D. Commercial information.</td>
              <td class="bl-padding--8">
                Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming
                histories or tendencies.
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">E. Biometric information.</td>
              <td class="bl-padding--8">
                Genetic, physiological, behavioral, and biological characteristics, or activity patterns used to extract a template or other
                identifier or identifying information, such as neural data, fingerprints, faceprints, and voiceprints, iris or retina scans,
                keystroke, gait, or other physical patterns, and sleep, health, or exercise data.
              </td>
              <td class="bl-padding--8">NO</td>
            </tr>
            <tr>
              <td class="bl-padding--8">F. Internet or other similar network activity.</td>
              <td class="bl-padding--8">
                Browsing history, search history, information on a consumer's interaction with a website, application, or advertisement.
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">G. Geolocation data.</td>
              <td class="bl-padding--8">Physical location or movements.</td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">H. Sensory data.</td>
              <td class="bl-padding--8">Audio, electronic, visual, thermal, olfactory, or similar information.</td>
              <td class="bl-padding--8">NO</td>
            </tr>
            <tr>
              <td class="bl-padding--8">I. Professional or employment-related information.</td>
              <td class="bl-padding--8">
                Current or past job history or performance evaluations. Information collected about you through your employment application
                or employment with us.
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">
                J. Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R.
                Part 99)).
              </td>
              <td class="bl-padding--8">
                Performance management information such as employment status (full-time or part-time, regular or temporary), work schedule,
                job assignments, hours worked, accomplishments and awards, training and development, performance evaluation, employment
                termination.
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
            <tr>
              <td class="bl-padding--8">K. Inferences drawn from other personal information.</td>
              <td class="bl-padding--8">
                Profile reflecting a person's preferences, characteristics, psychological trends, predispositions, behavior, attitudes,
                intelligence, abilities, and aptitudes.
              </td>
              <td class="bl-padding--8">NO</td>
            </tr>
            <tr>
              <td class="bl-padding--8">L. Sensitive Personal Information.</td>
              <td class="bl-padding--8">
                Personal information that reveals a person's social security, driver's license, state identification card, passport number;
                an account log-in, financial account, debit card, or credit card number in combination with any required security or access
                code, password, or credentials allowing access to an account; precise geolocation; racial or ethnic origin, religious or
                philosophical beliefs, or union membership; the contents of a consumer's mail, email, and text messages unless the business
                is the intended recipient of the communication; a person's genetic data; and/or biometric data processed for the purpose of
                uniquely identifying a person.
              </td>
              <td class="bl-padding--8">YES</td>
            </tr>
          </tbody>
        </table>
      </section>
      <section class="bl-margin-bottom--24">
        <p class="bl-margin-bottom--8">
          <span class="bl-font-weight--700 bl-font-size--18">Sources of Personal or Sensitive Information.</span>
          We obtain the categories of personal information listed above from the following categories of sources:
        </p>
        <ul class="bl-bulleted-list">
          <li>
            Directly from you or your agents. For example, from documents that our clients provide to us related to the services for which
            they engage us on your behalf.
          </li>
          <li>
            Indirectly from our clients or their agents. For example, through information we collect from our clients, in the course of
            providing services to them.
          </li>
          <li>
            Directly and indirectly from activity on our systems and/or websites. For example, from submissions through our website portals
            or website usage details collected automatically.
          </li>
          <li>From third-parties that interact with us in connection with the services we perform.</li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <h3 class="bl-text-style--display-6 bl-margin-bottom--8">
          <span class="bl-font-color--steel bl-font-weight--800">Business Purpose for Disclosing Personal or Sensitive Information.</span>
        </h3>
        <p class="bl-margin-bottom--8">
          Disclosure of your personal information may have been made in the preceding 12 months to these categories of our affiliates, and
          non-affiliated third parties for a business purpose, unless otherwise restricted by applicable law:
        </p>
        <ul class="bl-bulleted-list">
          <li>
            To third parties to provide you with services you have requested, and to enable us to detect or prevent fraud,
            misrepresentation, or criminal activity.
          </li>
          <li>
            To contracted third parties that provide services on our behalf and use the information only in connection with such services.
          </li>
          <li>
            To law enforcement or other government authorities in connection with an investigation, civil or criminal subpoena, or court
            order.
          </li>
          <li>
            To other third parties with whom you have given us written, including electronic authorization to disclose your personal
            information.
          </li>
          <li>To investigate potential unauthorized use of our Information Channel.</li>
          <li>
            To share and use, for any purpose, the personal information if it is in an aggregated, anonymized form, so that you are not
            identified (collectively, “De-Identified Data”)
          </li>
          <li>
            In connection with a sale, transfer or other disposition of all or part of Origence’s business/assets, or in the event of
            bankruptcy, reorganization, receivership, insolvency, or assignment for the benefit of creditors.
          </li>
          <li>
            For any purpose disclosed by us to you when you provide the information, and as directed by you, or with your permission.(i) to
            understand and analyze trends and preferences; (ii) to monitor and analyze our services’ effectiveness; (iii) to improve our
            services and develop new products, services, features, and functionality; (iv) to personalize our services, such as remembering
            your information so that you will not have to re-enter it during your visit or the next time you use our services, and (v) to
            provide customized content and information.
          </li>
        </ul>

        <p class="bl-margin-bottom--8">
          In the preceding twelve (12) months, we have disclosed the following categories of personal information for a business purpose:
        </p>
        <ul class="bl-bulleted-list">
          <li>Category A: Identifiers</li>
          <li>Category B: California Customer Records personal information categories</li>
          <li>Category C: Protected classification characteristics under California or federal law</li>
          <li>Category D: Commercial information</li>
          <li>Category G: Geolocation data</li>
          <li>Category I: Professional or employment-related information</li>
          <li>Category J: Non-public education information</li>
          <li>Category L: Sensitive Personal Information</li>
        </ul>

        <p class="bl-margin-bottom--8">
          To the extent that you are a current or former employee or applicant, Origence may use your personal or sensitive personal
          information for the following purposes and does not use sensitive information beyond what is necessary to:
        </p>
        <ul class="bl-bulleted-list">
          <li>
            Collect equality and diversity information, such as minority, veteran and disability status, through voluntary self-disclosure
            and other means to implement the Company's diversity programs and comply with applicable laws.
          </li>
          <li>Administer and provide compensation, benefits, and other work-related allowances, as applicable.</li>
          <li>
            Manage our information technology (computers, phones, company systems, and applications) and information security, including the
            helpdesk, corporate directory, IT support, fraud prevention, and information security.
          </li>
        </ul>
      </section>
      <section>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Right to Delete</span>
          personal information collected about them, subject to certain exceptions. Once we receive a verified consumer request, we will
          erase your personal information from our records, unless an exception applies, or if we have de-identified or aggregated the
          personal information. There may be instances where applicable law and regulatory requirements allow or require us to retain
          personal information. We may deny a deletion request if it is necessary for us or our service providers to maintain your personal
          information for any of the reasons set forth in the CCPA.
        </p>
        <p>
          Most of the personal information Origence obtains is subject to the CCPA exemptions for personal information subject to the
          Gramm-Leach-Bliley Act (“GLBA”) and the Fair Credit Reporting Act (“FCRA”).
        </p>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Right to opt-out</span>
          of the sale or sharing of their personal information. Origence does not “sell” or “share” consumer personal information.
        </p>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Right of Non-Discrimination</span>
          for exercising their CCPA rights. We will not discriminate against you for exercising any of your rights in this Privacy Policy
          and under applicable laws.
        </p>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Right to Correct</span>
          inaccurate personal information. To update or correct your personal information in our possession, please refer to the "How to
          Contact Us" section at the beginning of this Privacy Policy. If you are receiving consumer services, please contact your financial
          institution for questions or to exercise your CCPA rights.
        </p>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Right to Limit</span>
          use of sensitive personal information collected about them. Origence does not use or disclose sensitive personal information for
          purposes other than those expressed herein or otherwise permitted by applicable law.
        </p>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Data Retention.</span>
          Our retention periods are based upon business needs and legal requirements. We retain information for as long as is necessary for
          the purpose(s) for which the information was collected, and any other permissible related purpose.
        </p>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Information From Children.</span>
          We do not intentionally collect information from children who are under the age of 16, and neither our website nor our services
          are directed to children under the age of 16.
        </p>
        <p>
          <span class="bl-font-weight--700 bl-font-size--18">Exercising Your Rights.</span>
          If you are receiving consumer services, please contact your financial institution to exercise your CCPA rights.
        </p>
        <p>
          To exercise your rights for personal information that we collect, use and process for our business purposes, please submit a
          verifiable consumer request to us. You may only make a verifiable consumer request for access or data portability twice within a
          12-month period.
        </p>

        <p class="bl-margin-bottom--8">A verifiable consumer request must:</p>
        <ul class="bl-bulleted-list">
          <li>
            Provide enough information that allows us to reasonably verify you are the person about whom we collected personal information
            or an authorized representative; and
          </li>
          <li>Describe your request with enough detail that allows us to properly understand, evaluate, and respond to it.</li>
        </ul>
      </section>
      <section class="bl-margin-bottom--24">
        <p><span class="bl-font-weight--700">You may submit your request in either of these following methods:</span></p>
        <p>
          By email:
          <a href="mailto:clientsupport@origence.com">clientsupport&#64;origence.com</a>
        </p>
        <p>
          By toll free number:
          <a href="tel:+18777442835">877-744-2835</a>
          option 1
        </p>
        <p>
          Consumers with disabilities may contact us using any of the contact information provided below to receive this notice in an
          accessible format.
        </p>
        <p>
          <span class="bl-font-style--italic">When using an Authorized Agent.</span>
          You may designate an authorized agent to make a request under the CCPA on your behalf. You will need to provide the authorized
          agent written permission to make requests on your behalf, and the agent will need to verify their own identity. We may deny a
          request from an agent that does not submit proof that they have been authorized by you to act on your behalf.
        </p>
      </section>
      <section class="bl-margin-bottom--24 bl-padding-top--24 bl-border-top--1 bl-border-color--mist">
        <h3 class="bl-text-style--display-5 bl-margin-bottom--16">
          <span class="bl-font-color--steel bl-font-weight--800">For Canadian Residents:</span>
        </h3>
        <p>
          Origence as a U.S.-based service provider offering services to Canadian consumers, is committed to protecting the privacy and
          personal information of individuals in Canada. To learn how we collect, use, disclose and safeguard your personal information,
          please visit the
          <a href="https://origence.com/resources/privacy-policy-canada" rel="noopener noreferrer" target="_blank">Canada Privacy Policy</a>
          .
        </p>
      </section>
    </article>
  </div>
</div>
